export function buildLogForRule(rule, state, isQualified, logicArgs) {
  const logic = rule.logic.toString();
  const assertion = logic
    .slice(logic.indexOf("{") + 1, logic.lastIndexOf("}"))
    .replace(/[\r\n;]/gm, '')
    .replace('return', '')
    .trim();

  let input = rule.inputTypes.map(type => `${type}: ${state[type]}`);

  if(logicArgs)
    Object.entries(logicArgs).forEach(([key, value]) => input.push(`${key}: ${value}`));

  return `${isQualified ? 'PASSED' : 'FAILED'}: ${rule.ruleType}=>(${assertion}), input:[${input}]`;
}